module.exports = __webpack_public_path__ + "img/icon_bianpao_logo_n.a687bd55.png";